module.exports = __webpack_public_path__ + "static/media/paper_hero_desktop.a30c4557.jpg";